import { useState } from 'react';

const useDropDown = (jobTitles = []) => {
  const [search, setSearch] = useState('');
  const [status, setStatus] = useState('');

  const filteredJobTitles = jobTitles.filter(field => {
    const isMatch = field[0] ? field[0]?.toLowerCase().startsWith(search.toLowerCase()) : '';
    const isStatus = field[3] === status || status === '';
    if (isMatch && isStatus) {
      return field;
    }
    return null;
  });

  return {
    setSearch,
    setStatus,
    filteredJobTitles,
  };
};

export default useDropDown;
